export default __webpack_public_path__ + "static/media/check-circle.cce54dbd.svg";